import React from 'react';
import { useApp } from '../../../context/AppContext';
import { jlptLevels } from '../../../data/jlptLevels';
import styles from './JlptHero.module.css';

/**
 * Hero section for the JLPT page with interactive level pills.
 * Clicking a pill sets the level and scrolls to the placement test.
 */
function JlptHero() {
  const { selectedLevel, setSelectedLevel } = useApp();

  function handlePillClick(code) {
    setSelectedLevel(code);
    setTimeout(() => {
      const testSection = document.getElementById('jlpt-test');
      if (testSection) {
        testSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  }

  return (
    <div className={styles.hero} aria-label="JLPT Hero">
      <div className={styles.badge}>JLPT – 日本語能力試験</div>
      <div className={styles.jpSub} lang="ja">言語を身につけ、世界を広げる</div>
      <h1 className={styles.heading}>
        Tiếng Nhật như một ngôn ngữ thứ hai —<br />
        không phải môn học <em>để thi</em>
      </h1>
      <p className={styles.sub}>
        Lộ trình JLPT tại Annie Class xây dựng năng lực ngôn ngữ theo nguyên tắc acquisition:
        học viên phát triển khả năng tư duy, phản xạ và biểu đạt bằng tiếng Nhật — đủ để tự
        tin trong môi trường làm việc, du học hay hội nhập văn hoá Nhật Bản.
      </p>
      <div className={styles.levelsRow} role="group" aria-label="Chọn cấp độ JLPT">
        {jlptLevels.map((lv) => (
          <button
            key={lv.code}
            className={[
              styles.pill,
              selectedLevel === lv.code ? styles.active : '',
            ].join(' ')}
            onClick={() => handlePillClick(lv.code)}
            aria-pressed={selectedLevel === lv.code}
          >
            Thi thử {lv.code}
          </button>
        ))}
      </div>
    </div>
  );
}

export default JlptHero;
